import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

import { Partition } from '@classes/simulation/partition';
import { Partitioning } from '@classes/partitioning';
import { OriginCategory } from '@classes/origin/origin-category';
import { PartitioningService } from '@services/partitioning.service';
import { UiService } from '@services/ui.service';
import { ReportService } from '@services/report.service';
import { FileService } from '@services/file.service';
import { FileInfo } from '@classes/file/file-info';
import { FileImport } from '@classes/file/file-import';
import { FileSource } from '@enums/file-source.enum';

@Component({
    selector: 'app-upload-simulation',
    templateUrl: './upload-simulation.component.html',
    styleUrls: ['./upload-simulation.component.scss']
})
export class UploadSimulationComponent implements OnInit, OnDestroy {
    private loadingSub: Subscription;

    partitions: Partition[];
    partitionings: Partitioning[];
    selectForm: FormGroup;
    categories: OriginCategory[];
    selPartitioningCode: string;
    selectedPartitions: string[] = [];
    selectedCategories: string[];
    doesIncludeArticles: boolean;
    isClientImport = false;
    isLoading: boolean;

    constructor(
        private partitioningSrv: PartitioningService,
        private uiSrv: UiService,
        private fb: FormBuilder,
        private reportSrv: ReportService,
        private fileSrv: FileService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    onSelectPartition(selectedCodes: string[]): void  {
        this.selectedPartitions = [ ... selectedCodes ];
    }

    onDownload(): void {
        this.isLoading = true;
        this.reportSrv.generateXlsPartitions(this.selectedPartitions, this.selPartitioningCode, this.doesIncludeArticles, this.selectedCategories)
        .subscribe(() => this.isLoading = false);
    }

    onSendFilesInfo(filesInfo: FileInfo[]): void {
        const fileImport = new FileImport(
            FileSource.simulation,
            filesInfo,
            this.isClientImport,
            {
                partitioning: this.selPartitioningCode
            }
        );

        this.fileSrv.import(fileImport)
            .subscribe(() => {
                this.fileSrv.getFiles().subscribe();
            });
    }

    private initSubscriptions(): void {
        this.partitioningSrv.getList()
        .subscribe(partsFromSrv => {
            this.partitionings = partsFromSrv;
            this.initForm();
        });

        this.loadingSub = this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
            this.isLoading = loadingState;
        });
    }

    private initForm(): void {
        this.selectForm = this.fb.group({
            partitioning: ['']
        });

        this.selectForm.controls.partitioning.valueChanges
        .subscribe((code: string) => {
            this.selPartitioningCode = code;
            this.getPartitions();
        });
    }

    private getPartitions(): void {
        this.isLoading = true;
        this.partitions = [];
        this.selectedPartitions = [];

        this.partitioningSrv.getPartitions(this.selPartitioningCode)
        .subscribe(response => {
            this.partitions = [ ...response.partitions ];
            this.categories = [ ...response.amountTypes ];
            this.selectedCategories = this.categories.length ? [this.categories[0].code] : [];
            this.isLoading = false;
        });
    }

    ngOnDestroy(): void {
        if(this.loadingSub) {
            this.loadingSub.unsubscribe();
        }
    }
}
